import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { DataStatus } from 'src/core/engine/types';

import { Step } from '../feature/customisation.types';
import { AppendState, CustomisationMsg } from '../feature/customisation.actions';

const selector = (state: AppendState) => {
    return state.customisation;
};

export function useCustomisation() {
    const state = useSelector(selector, shallowEqual);
    const dispatch = useDispatch();

    const loadStep = useCallback(
        (input: { step: Step; search?: string }) => {
            dispatch(CustomisationMsg('Customisation.LoadStep', input));
        },
        [dispatch],
    );

    return {
        loadStep,
        isPending: state.status === DataStatus.Pending,
        state,
    };
}
